
export enum PlugType {
  Type2= 'Type2',
  CCSType2= 'CCSType2',
  Other= 'Other',

}